import clsx from "clsx";
import React from "react";

type Props = {
  title: string;
  value: string;
  metaData?: boolean;
};

export const TooltipItem = ({ title, value, metaData }: Props) => {
  return (
    <div className="flex mb-10">
      <span className={clsx("w-[60px] text-right font-bold mr-2", metaData ? "text-[#cccccc]" : "text-[#888888]")}>
        {title}
      </span>
      <span className={clsx("w-[180px] text-left", metaData ? "text-[#cccccc]" : "")}>{value}</span>
    </div>
  );
};
